import { ResponseError } from '~/utils';
import ProductDetailsMock from '../mocks/productDetails.json';
import SimulationPlansMock from '../mocks/simulationPlans.json';
import request from '../request';

export const getProductsDetails = async (
  id: string,
): Promise<CreditProductsDetails> => {
  try {
    return ProductDetailsMock as CreditProductsDetails;
    const { data } = await request.get(
      `/credit-services/holders/me/credit/products/${id}`,
    );
    return data;
  } catch (error) {
    throw new ResponseError(error);
  }
};

export const getSimulationPlans = async (
  amount: number,
  id: string,
): Promise<SimulationPlansResponse> => {
  try {
    return SimulationPlansMock as SimulationPlansResponse;
    const { data } = await request.post(
      `/credit-services/holders/me/credit/products/${id}/simulation`,
      { amount },
    );
    return data;
  } catch (error) {
    throw new ResponseError(error);
  }
};
